<template>
  <v-app class="device-register blue">
    <v-container grid-list-lg>
      <v-layout row wrap>                            
        <v-flex xs12 md5>              
          <v-card class="pa-3 elevation-5" >
            <v-card-text>
              <div class="layout column align-center mb-3">
                <img src="@/assets/logo.png" alt="Vue Material Admin" height="80">
                <h2 class="mt-2 mb-4 primary--text">Daftar Baru / Signup</h2>    
                <v-alert value="true" color="warning" icon="info" outline>Halaman ini hanya untuk pendaftar yang belum punya username dan password. Jika sudah tedaftar sebelumnya click <a href="#/login">disini</a> untuk login</v-alert>                
              </div>                               
              <template v-if="!verification">
                <v-text-field prefix="+62" placeholder="812" name="phone" label="no hp anda / phone number" type="number" v-model="formModel.phone" hide-details>
                  <template v-slot:append>
                    <v-fade-transition leave-absolute>
                      <v-progress-circular
                        v-if="loadingotp"
                        size="24"
                        color="info"
                        indeterminate
                      ></v-progress-circular>
                      <template v-else>
                        <v-btn v-if="!otpsent" small class="green" @click="sendOtp" dark>Req Otp</v-btn>
                        <v-icon v-else color="green">check</v-icon>
                      </template>                        
                    </v-fade-transition>
                  </template>
                </v-text-field>              
                <div id="recaptcha-container"></div><br>
                <v-text-field name="otp" style="width:150px" label="Kode OTP" type="number" v-model="formModel.otp"></v-text-field>
                <v-btn block color="primary" @click="verifyOtp" :loading="loading">Verifikasi</v-btn>
              </template>
              <template v-else>
                <div id="recaptcha-container"></div><br>
                <label>Pilih jenjang pendidikan yang akan dituju</label>
                <div class="mb-4">                  
                  <input type="radio" v-model="formModel.tingkat_id" class="mr-1" :value="1"/> SD &nbsp; &nbsp;
                  <!--<input type="radio" v-model="formModel.tingkat_id" class="mr-1" :value="2"/> SMP &nbsp; &nbsp;
                  <input type="radio" v-model="formModel.tingkat_id" class="mr-1" :value="3"/> MA-->
                </div>
                <v-text-field :prefix="telmode ?'+62':'other:'" 
                  :placeholder="telmode?'812':'+97'" 
                  name="phone" 
                  append-icon="phone"
                  @click:append="telmode=!telmode"
                  label="no hp anda(wali) / phone number" 
                  :type="telmode ?'number':'text'"                   
                  v-model="formModel.phone" 
                  v-validate="'required'"
                  data-vv-name="phone"     
                  :error-messages="errors.collect('phone')"  
                  required
                >                 
                </v-text-field>                
                <v-text-field append-icon="email" 
                  name="email" 
                  label="Email" 
                  type="email" 
                  v-model="formModel.email"
                  v-validate="'required'"
                  data-vv-name="email"     
                  :error-messages="errors.collect('email')"  
                  required
                ></v-text-field>
                <v-text-field append-icon="person" 
                  name="username" 
                  label="Username Baru" 
                  type="text" 
                  v-model="formModel.username"
                  v-validate="'required'"
                  data-vv-name="username"     
                  :error-messages="errors.collect('username')"  
                  required
                ></v-text-field>                
                <v-text-field                      
                  name="password" 
                  label="Password Baru" 
                  id="password" 
                  v-model="formModel.password" 
                  @keyup.enter="register"                      
                  :append-icon="showpass ? 'visibility' : 'visibility_off'"                    
                  :type="showpass ? 'text' : 'password'"
                  @click:append="showpass = !showpass"        
                  v-validate="'required'"
                  data-vv-name="password"     
                  :error-messages="errors.collect('password')"  
                  required
                ></v-text-field>
              </template>                            
            </v-card-text>            
            <v-card-actions v-if="verification" class="pa-3">   
              <small class="mr-3">Dengan mengklik daftar berarti anda telah menyetujui kebijakan privasi<br/><i>
                Clicking on the button means that you agree to the privacy policy
                </i></small>
              <v-spacer></v-spacer>
              <v-btn block color="primary" @click="register()" :loading="loading">Daftar</v-btn>
            </v-card-actions>
            <v-card-text class="pa-0">
              <v-alert :value="true" type="warning">
                Username dan Password ananda jangan sampai lupa !
              </v-alert>
            </v-card-text>
            <v-card-actions class="px-3"> 
              <a href="#/login"><small>sudah punya akun ?<br/><i>Already have an account ?</i></small></a>
            </v-card-actions>   
          </v-card>
        </v-flex>             
        <v-flex xs12 md7>
          <v-card class="elevation-5">
            <v-card-text class="pa-0" style="height:95vh; overflow-y: auto">      
              <v-tabs color="grey lighten-3">
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab key="1" href="#tab1">Kebijakan Privasi</v-tab>
                <v-tab key="2" href="#tab2">Privacy Policy</v-tab>
                <v-tabs-items>
                  <v-tab-item key="1" value="tab1">
                    <v-card flat>
                      <v-card-text>                        
                        <p class="caption">Kami, Yayasan Arrisalah, menganggap bahwa perlindungan terhadap privasi pengguna adalah kepentingan yang utama. Oleh karenanya, kami dengan ini menyampaikan kebijakan privasi kami (“Kebijakan Privasi” ini) yang bertujuan untuk menjelaskan penanganan informasi pribadi oleh kami dan dengan tetap menyediakan layanan unggulan kepada pengguna.</p>
                        <ul class="caption">
                          <li>Kami menyatakan bahwa kami mungkin menyediakan sebagian dari informasi pribadi Anda kepada pihak pengelola dari yayasan Arrisalah. </li>
                          <li>Pembagian penggunaan informasi pribadi ini diimplementasikan secara terbatas, hanya selama diperlukan dan dalam lingkup tanggung jawab kami.</li>
                        </ul>
                        <p class="caption mt-3">Saat Anda membuat sebuah akun untuk mengakses Layanan PPDB, kami akan meminta Anda untuk memberikan nomor telepon Anda. Informasi ini penting karena kami akan mengirimkan kepada Anda pesan teks melalui SMS atau telepon ke nomor telepon yang Anda berikan, sebagai bagian dari upaya yang kami lakukan untuk mendeteksi dan menghalangi penggunaan oleh pihak yang tidak berwenang atau curang atas, atau penyalahgunaan Layanan. Kami juga mungkin menggunakan nomor telepon Anda yang terdaftar untuk memberikan informasi penting mengenai Layanan.</p>
                      </v-card-text>                      
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="2" value="tab2">
                    <v-card flat>
                      <v-card-text>
                        <p class="caption">We, the Arrisalah Foundation, consider that protecting the privacy of users is of primary importance. Therefore, we hereby submit our privacy policy ("Privacy Policy") which aims to explain the handling of personal information by us and while providing superior service to users.</p>
                        <ul class="caption">
                          <li>We declare that we may provide some of your personal information to the manager of the Arrisalah foundation.</li>
                          <li>Sharing of the use of personal information is implemented on a limited basis, only as long as necessary and within the scope of our responsibilities.</li>
                        </ul>
                        <p class="caption mt-3">When you create an account to access PPDB Services, we will ask you to provide your telephone number. This information is important because we will send you text messages via SMS or telephone to the telephone number you provide, as part of our efforts to detect and obstruct unauthorized or fraudulent use of the Service, or abuse of the Service. We may also use your registered telephone number to provide important information about the Service.</p>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>                                  
            </v-card-text>
          </v-card>                            
        </v-flex>
      </v-layout>
    </v-container>          
  </v-app>
</template>

<script>
import config from '@/config';  
import User   from '@/util/models/User';  
import firebase from 'firebase';

const assets = require.context('@/assets/');
export default {
  $_veeValidate: {validator: 'new'},  
  components: {
    
  },      
  data () {
    return {
      formModel : {
        phone : '',
        username : null,
        password : null,
        email : null,
        tingkat_id: null,
        otp : null
      },      
      telmode:true,
      otpsent : false,
      verification : true,
      loading : false,
      loadingotp : false,
      color:config.color, 
      showpass:false,
      appVerifier : '',
      token:{}
    }  
  },
  computed: {
    computeImage(gambar) {
      return assets('./bg/accounting.jpg');
    },
  },
  mounted(){
    if(this.$route.query.tingkat_id){
      this.formModel.tingkat_id = this.$route.query.tingkat_id
    }
    firebase.auth().languageCode = 'id';
    this.initReCaptcha();
  },
  methods: {    
    register() {
      let tingkat = 'SD';
      switch(this.formModel.tingkat_id){
        case 2: tingkat = 'SMP'; break;
        case 3: tingkat = 'MA'; break;      
      }
      this.$swal({
            title: "Konfirmasi",
            text: "Apakah ananda yakin mendaftar di tingkat "+tingkat+"?",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ya, saya yakin"
        }).then((result) => { // <--
            if (result.value) {
              this.loading = true;
              User.signup(this.formModel).then(response => {
                if(response.status == 200){        
                  this.token = response.data;
                  User.set(this.token);           
                  window.getApp.$emit('showSnackbar', {text:'Register Succesfully. Welcome to Arrisalah Portal. ',show:true, color:'green'});        
                  setTimeout(() => {this.$router.push('/dashboard?tingkat_id='+this.formModel.tingkat_id);}, 1000);
                } else if(response.data && Array.isArray(response.data)) {
                  this.validate(response.data);
                } 
                setTimeout(() => {this.loading = false;}, 500);
              });
            }
        });              
    },
    
    validate(data){
      data.forEach( (item) => {
        this.$validator.errors.add({field : item.field,msg : item.message});
      });
    },  
   
    sendOtp(){
        if(this.formModel.phone.length < 9){
          window.getApp.$emit('showSnackbar', {text:'Invalid Phone Number Format !', show:true, color:'orange'});                                  
        }else{
          //
          let countryCode = '+62' //indonesia
          let phoneNumber = countryCode + this.formModel.phone;
          //
          let appVerifier = this.appVerifier;
          //
          this.loadingotp = true; let vm = this;
          firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
            .then(function (confirmationResult) {
              // SMS sent. Prompt user to type the code from the message, then sign the
              // user in with confirmationResult.confirm(code).
              window.confirmationResult = confirmationResult;
              window.getApp.$emit('showSnackbar', {text:'SMS sent', show:true, color:'green'});
              vm.otpsent = true;              
              vm.loadingotp = false;
              setTimeout(()=>{vm.otpsent = false;}, 30000);
            }).catch(function (error) {
            // Error; SMS not sent
            // ...
            console.log(phoneNumber, 'Error ! SMS not sent', appVerifier);
            vm.loadingotp = false;
            window.getApp.$emit('showSnackbar', {text:'Error ! SMS not sent', show:true, color:'red'});                        
          });
          
        }
      },
      //
      verifyOtp(){
        if(this.formModel.length < 9 || this.formModel.otp.length !== 6){          
          window.getApp.$emit('showSnackbar', {text:'Invalid Phone Number/OTP Format !', show:true, color:'orange'});                        
        }else{
          //
          let vm = this
          let code = this.formModel.otp
          this.loading = true;
          //
          window.confirmationResult.confirm(code).then(function (result) {
            // User signed in successfully.
            var user = result.user;
            // ...
            //route to set password !
            //vm.$router.push({path:'/home'})
            vm.loading = false;
            vm.verification = true;            
          }).catch(function (error) {
            // User couldn't sign in (bad verification code?)
            // ...
            window.getApp.$emit('showSnackbar', {text:'User couldn\'t sign in (bad verification code)', show:true, color:'red'});  
          });
        }
      },
      
      initReCaptcha(){
        //setTimeout(()=>{
          let vm = this
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function(response) {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
            },
            'expired-callback': function() {
              // Response expired. Ask user to solve reCAPTCHA again.
              // ...
            }
          });
          //
          this.appVerifier =  window.recaptchaVerifier          
        //},1000)
      }
    },
    
};
</script>
<style scoped lang="css">
  .device-register {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
